{
  "instances": {
    "dependencies": {
      "label": "相依元件",
      "list": {
        "header": {
          "group": "群組",
          "name": "名稱",
          "version": "版本",
          "publisher": "發布者",
          "description": "說明",
          "licenses": "授權條款"
        }
      }
    }
  }
}
